import React from 'react';
import PropTypes from 'prop-types';
import {
  Dropdown,
  Menu,
} from 'antd';

const generateMenu = dataSource => (
  <Menu>
    {
      dataSource.map(({ children, ...data }) => (
        <Menu.Item {...data}>
          {children}
        </Menu.Item>
      ))
    }
  </Menu>
);

const DropdownMenu = ({
  children,
  dataSource,
  ...props
}) => (
  <Dropdown {...props} overlay={generateMenu(dataSource)}>
    {children}
  </Dropdown>
);

DropdownMenu.propTypes = {
  children: PropTypes.any.isRequired,
  dataSource: PropTypes.arrayOf(PropTypes.shape({
    children: PropTypes.any.isRequired,
    key: PropTypes.string.isRequired,
  })).isRequired,
  disabled: PropTypes.bool,
  trigger: PropTypes.arrayOf(PropTypes.string),
};

DropdownMenu.defaultProps = {
  disabled: false,
  trigger: ['click'],
};

export default DropdownMenu;



// WEBPACK FOOTER //
// ./src/components/shared/DropdownMenu.js